module.exports = __webpack_public_path__ + "img/vegetable-endive-190x100.68ee9324.jpg";